<script lang="ts">
  import { _ } from 'svelte-i18n';
  import { AppState } from '../../etc/stores';
  import { formatMoney } from '../../etc/utils';
  import Button from '../../components/form/Button.svelte';
  import Link from '../../components/misc/Link.svelte';
  import Heading from '../../components/typography/Heading.svelte';
  import Label from '../../components/typography/Label.svelte';
  import Welcome from '../../components/templates/Welcome.svelte';
  import BorderDashed from '../../components/misc/BorderDashed.svelte';
  import { replaceVariables } from '../../i18n';
  import CoinV2 from '../../components/icons/CoinV2.svelte';

  const isBlack = $AppState.theme.name === 'black';

  const t = (text: string, values: any = {}) => {
    return replaceVariables($_(`welcome.${text}`), values);
  };

  const isReferredState = !!$AppState.referralReferredState.id;
  const hasMessage = isReferredState || $AppState.freeCoinsCampaign.id;

  const getMessageText = () => {
    if (isReferredState) {
      return t('referred', {
        referringFirstName:
          $AppState.referralReferredState.referringCustomer.name
      });
    }

    return t('free-coins', {
      moneyAmount: formatMoney(
        $AppState.business.location,
        $AppState.freeCoinsCampaign.coinsReward
      )
    });
  };
</script>

<Welcome let:onJoin let:onSignIn let:loading>
  <div class="welcome__loyalty">
    <Heading
      type={hasMessage ? 'h3' : 'h2'}
      color="#FFF"
      class="welcome__loyalty__label {!hasMessage ? 'mt' : ''}"
      textAlign="center"
    >
      {@html t('loyalty', {
        LOYALTY_PERCENTAGE: Number(
          $AppState.business.rewardsSettings.coinRewardPercentage
        )
      })}
    </Heading>
  </div>
  {#if hasMessage}
    <div
      class="welcome__free-coins"
      style={`background: ${$AppState.theme.colors.primary500}14;`}
    >
      <CoinV2 size="16" color="#FFF" style="max-height: 16px;" />
      <BorderDashed class="welcome__free-coins-dashed" />
      <Label
        type="medium-regular"
        color="#FFF"
        class="welcome__text-free-coins"
      >
        {getMessageText()}
      </Label>
    </div>
  {/if}
  <div class="welcome__button" class:no-mt={hasMessage}>
    <Button
      schema={isBlack ? 'white' : 'primary'}
      class="welcome_button-join"
      label={t('btn_join')}
      on:click={() => onJoin()}
      {loading}
    />
    <div class="welcome__button__link">
      <Label color="#ffffff99" class="welcome__already" type="medium-regular">
        {t('already')}
      </Label>
      <Link
        style="color: #FFF;"
        class="welcome__already"
        width="auto"
        on:click={onSignIn}
        fontSize="14px"
        fontWeight="600"
      >
        {t('btn_signin')}
      </Link>
    </div>
  </div>
</Welcome>

<style lang="scss">
  :global(.welcome__free-coins-dashed) {
    position: absolute;
    top: 0;
    width: 100% !important;
  }

  :global(.welcome__loyalty__label) {
    line-height: 25px !important;
  }

  :global(.welcome__loyalty__label, .mt) {
    @media screen and (max-width: 468px) and (min-height: 700px) {
      font-size: 24px !important;
      line-height: 33px !important;
    }
  }

  :global(.welcome_button-join) {
    @media screen and (max-width: 468px) and (min-height: 700px) {
      height: 56px !important;
    }
  }

  :global(.welcome_button-join .twism-text-button) {
    @media screen and (max-width: 468px) and (min-height: 700px) {
      font-size: 18px !important;
      font-weight: 600 !important;
    }
  }

  :global(.welcome__already) {
    margin-right: 4px !important;
    @media screen and (max-width: 468px) {
      font-size: 15px !important;
    }
    @media screen and (max-width: 468px) and (min-height: 700px) {
      font-size: 16px !important;
      line-height: 21px !important;
    }
  }

  :global(.welcome__free-coins-icon) {
    height: 19px !important;
    width: 22px !important;
    max-height: 19px !important;
  }

  .welcome {
    &__loyalty {
      margin-top: 12px;
      padding: 4px 8px;
      border-radius: 6px;
      @media screen and (max-width: 468px) and (min-height: 700px) {
        margin-top: 20px;
      }
    }

    &__free-coins {
      width: 100%;
      border-radius: 12px;
      box-sizing: border-box;
      height: 59px;
      padding: 12px;
      display: flex;
      justify-content: center;
      margin-bottom: -20px;
      margin-top: 24px;
      position: relative;
    }

    &__button {
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
      margin: 24px 0 40px;

      &.no-mt {
        margin: 0 0 24px;
        @media screen and (max-width: 468px) and (min-height: 700px) {
          margin: 0 0 40px;
        }
      }

      &__link {
        margin-top: 16px;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
</style>
